"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getDocumentManagementInstructions } from "@/src/requests/document-management-instructions";
const DOCUMENT_MANAGEMENT_INSTRUCTIONS_CACHE_KEY = "document-management-instructions";
export function useDocumentManagementInstructions(taskId, options) {
  const $ = _c(16);
  let t0;
  let t1;
  if ($[0] !== taskId) {
    t0 = [DOCUMENT_MANAGEMENT_INSTRUCTIONS_CACHE_KEY, taskId];
    t1 = () => getDocumentManagementInstructions(taskId);
    $[0] = taskId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!taskId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = useQuery(t3);
  const t4 = query.data?.instructions;
  const t5 = query.data?.stepOutputs;
  const t6 = query.data?.ccDescription ?? null;
  let t7;
  if ($[7] !== query.error || $[8] !== query.isError || $[9] !== query.isFetching || $[10] !== query.isLoading || $[11] !== query.refetch || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = {
      instructions: t4,
      stepOutputs: t5,
      ccDescription: t6,
      isFetching: query.isFetching,
      isLoading: query.isLoading,
      isError: query.isError,
      error: query.error,
      refetch: query.refetch
    };
    $[7] = query.error;
    $[8] = query.isError;
    $[9] = query.isFetching;
    $[10] = query.isLoading;
    $[11] = query.refetch;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}